$(document).ready(function () {
  if (exist("#over-link-trabalheconosco")) {
    $("#over-link-trabalheconosco").mouseover(function () {
      $("#ilustra-trabalheconosco").addClass("animate-shake");
    });
    $("#over-link-trabalheconosco").mouseout(function () {
      $("#ilustra-trabalheconosco").removeClass("animate-shake");
    });
  }
});
